export default () => {

	// expand animation function
	function autoHeightAnimate(element, time) {
	  const curHeight = element.offsetHeight // Get Default Height
	  element.style.height = 'auto'
	  const autoHeight = element.offsetHeight // Get Auto Height
	  element.style.height = curHeight + 'px' // Reset to Default Height
	  setTimeout(() => {
	    element.style.transition = `height ${time}ms`
	    element.style.height = autoHeight + 'px'
	  }, 100)

	  element.addEventListener('transitionend', function handler() {
	    element.style.height = 'auto' // Reset to Auto Height after animation
	    element.style.transition = ''
	    element.removeEventListener('transitionend', handler)
	  })
	}

	function autoHeightAnimateClose(element, time, height) {
	  const curHeight = element.offsetHeight // Get Default Height
	  element.style.height = curHeight + 'px' // Set to Default Height
	  setTimeout(() => {
	    element.style.transition = `height ${time}ms`
	    element.style.height = `${height}px`
	  }, 100)

	  element.addEventListener('transitionend', function handler() {
	    // element.style.height = '' // Reset height after animation
	    element.style.transition = ''
	    element.removeEventListener('transitionend', handler)
	  })
	}

	// ! Menu
	const menuContainer = document.querySelector( '.site-header' )
	const mobileMenuButton = document.getElementById( 'mobile-menu' )

	// ! Menu - toggle mobile menu.
	mobileMenuButton.addEventListener( 'click', function (e) {
		e.preventDefault()

		if ( menuContainer.classList.contains( 'mobile-menu-open' ) ) {
			// If open, close menu
			menuContainer.classList.remove( 'mobile-menu-open' )
			mobileMenuButton.setAttribute( 'aria-expanded', false )
			autoHeightAnimateClose(menuContainer, 200, 90)
		} else {
			// If closed, open menu
			mobileMenuButton.setAttribute( 'aria-expanded', true )
			menuContainer.classList.add('mobile-menu-open')
			autoHeightAnimate(menuContainer, 200)
		}
	})

	// ! Menu - drop-down menu.
	const menuHasChildrenItems = document.querySelectorAll('.site-header #primary-menu .menu-item-has-children')
	const menuHasChildrenBtn = document.querySelectorAll('.site-header #primary-menu .menu-item-has-children > .toggle-dropdown')
	for ( let menuChildren of menuHasChildrenBtn ) {
		// get parent nodes.
		const menuParent = menuChildren.parentNode

		// Set ID and aria-labelledby for each button and drop-down
		const anchorLabel = menuChildren.textContent
		const anchorLabelStr = anchorLabel.replace(/\s+/g, '-').toLowerCase()
		menuParent.querySelector('button').setAttribute( 'id', anchorLabelStr )
		menuParent.querySelector('.sub-menu').setAttribute( 'aria-labelledby', anchorLabelStr )

		// toggle drop-down
		menuChildren.addEventListener( 'click', function (e) {
			e.preventDefault()

			if ( menuParent.classList.contains( 'menu-open' ) ) {
				// If open, close drop-down menu.
				menuParent.classList.add( 'fade-out' )
				menuParent.classList.remove( 'menu-open' )
				menuChildren.setAttribute( 'aria-expanded', false )
				setTimeout(function () {
				  menuParent.classList.remove('fade-out')
				}, 300)
			} else {
				// First remove all instances of .menu-open from .menu-item-has-children
				for ( let menuHasChildrenItem of menuHasChildrenItems ) {
					menuHasChildrenItem.classList.remove('menu-open')

					// Then set all toggle-dropdown buttons to aria-expanded false.
					const toggleDropdowns = menuHasChildrenItem.querySelectorAll('.toggle-dropdown')
					for (let toggleDropdown of toggleDropdowns) {
						toggleDropdown.setAttribute( 'aria-expanded', false )
					}
				}
				// If closed, open drop-down menu.
				menuChildren.setAttribute( 'aria-expanded', true )
				menuParent.classList.add( 'fade-in' )
				setTimeout( function () {
					menuParent.classList.add( 'menu-open' )
					menuParent.classList.remove('fade-in')
				}, 100 )
			}
		})
	}

	// ! Menu - hide drop-down menu on outside click
	document.addEventListener( 'mouseup', function (e) {
		for ( let menuChildren of menuHasChildrenBtn ) {
			// get parent node.
			const menuParent = menuChildren.parentNode

			if ( menuParent.classList.contains( 'menu-open' ) && e.target.closest( '#site-navigation' ) === null ) {
				menuParent.classList.remove( 'menu-open' )
				menuChildren.setAttribute('aria-expanded', false)
			}
		}
	})

	// ! Menu - hide drop-down using ESC key.
	document.addEventListener('keyup', function (e) {
        const key = e.key
		for ( let menuChildren of menuHasChildrenBtn ) {
			// get parent node.
			const menuParent = menuChildren.parentNode

			if ( menuParent.classList.contains( 'menu-open' ) && key === 'Escape' ) {
				menuParent.classList.remove( 'menu-open' )
				menuChildren.setAttribute( 'aria-expanded', false )
				menuParent.querySelector('button').focus()
			}
		}
    })

}
